import React from 'react'
import { SubTitle } from '../../../common/form-components/label/Label'
import FuelsPrices from './FuelsPrices'

const FillPrices = ({ inputs, onChangeInputs }) => {
  return (
    <>
      <SubTitle id="indicate.prices" />
      <FuelsPrices prices={inputs} onChange={onChangeInputs} />
    </>
  )
}

export default FillPrices
